import { Injectable, inject } from '@angular/core';
import { StopTypesService } from '@control-tower/platform-loads';
import { LoggerService } from '@pf/shared-services';
import {
    AbstractTypeEntityFacade,
    TypeEntityStore,
} from '@pf/shared/util-platform';
import { TypeEntityTypes } from '@pf/shared-common';

@Injectable()
export class StopTypeFacade extends AbstractTypeEntityFacade<StopTypesService> {
    constructor() {
        const stopTypesService = inject(StopTypesService);
        const store = inject(TypeEntityStore);
        const logger = inject(LoggerService);

        super(
            store,
            logger,
            stopTypesService,
            'stopTypeGetAll',
            TypeEntityTypes.StopType
        );
    }
}
